export enum ContextInstance {
    CbmImpl = "CbmImpl",
    AnalyticsImpl = "AnalyticsImpl",
    TelemetryImpl = "TelemetryImpl",
    TaskRouter = "TaskRouter",
    TwilioTelemetryProcessor = "TwilioTelemetryProcessor",
    VoiceControllerImpl = "VoiceControllerImpl",
    FlexUserServiceImpl = "FlexUserServiceImpl",
    ChannelNotesServiceImpl = "ChannelNotesServiceImpl",
    ErrorReporter = "ErrorReporter",
    LocalStorageImpl = "LocalStorageImpl",
    FeaturesServiceImpl = "FeaturesServiceImpl",
    ClientOptionsStore = "ClientOptionsStore",
    ConfigurationServiceImpl = "ConfigurationServiceImpl",
    ConversationsSdkImpl = "ConversationsSdkImpl",
    AccountConfigDataContainer = "AccountConfigDataContainer",
    PreviewOutboundServiceImpl = "PreviewOutboundServiceImpl",
    ClientImpl = "ClientImpl",
    LoggerMap = "LoggerMap",
    LoggerConfigImpl = "LoggerConfigImpl",
    AccountConfigStore = "AccountConfigStore",
    SessionImpl = "SessionImpl",
    DataClientImpl = "DataClientImpl",
    TokenRegistry = "TokenRegistry",
    SsoSetupServiceImpl = "SsoSetupServiceImpl",
    TelemetryClientMock = "TelemetryClientMock",
    ConferenceRecordingServiceImpl = "ConferenceRecordingServiceImpl",
    ClientEventEmitter = "ClientEventEmitter"
}

export class ContextManager {
    readonly #instancePool: Map<ContextInstance, object>;

    static newInstance() {
        return new ContextManager();
    }

    constructor() {
        this.#instancePool = new Map();
    }

    retrieveInstanceOf<T extends object>(name: ContextInstance, Constructor: new (t: ContextManager) => T): T {
        if (!this.#instancePool.has(name)) {
            this.#instancePool.set(name, new Constructor(this));
        }
        return this.#instancePool.get(name) as T;
    }

    





    setInstance<T extends object>(instance: T, instanceName: ContextInstance): void {
        
        if (typeof global === "undefined" || !process.env) {
            throw new Error("setInstance is not meant to be used externally");
        }
        this.#instancePool.set(instanceName, instance);
    }

    destroy(): void {
        const iterator = this.#instancePool.entries();

        let isDone = false;
        while (!isDone) {
            const iteratorResult = iterator.next();
            const { value, done } = iteratorResult as IteratorResult<
                [ContextInstance, object & { destroy?: () => void }],
                undefined
            >;
            isDone = !!done;
            if (value) {
                const [, instance] = value;
                instance.destroy?.();
            }
        }

        this.#instancePool.clear();
    }
}
